import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { getNewRoles } from 'modules/settings/api';

export const useMutationNewRoles = () => {
  const queryClient = useQueryClient();
  const { errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError, data } = useMutation(getNewRoles, {
    onError: () => errorToast(),
    onSettled: () => queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_NEW_ROLES),
  });

  return {
    newRolesMutate: mutateAsync,
    newRolesLoading: isLoading,
    newRolesError: isError,
    newRolesData: data,
  };
};
